// extracted by mini-css-extract-plugin
export var container = "HalfAndHalfContent-module--container--2DgT-";
export var leftSide = "HalfAndHalfContent-module--left-side--2JiDP";
export var gradientBackground = "HalfAndHalfContent-module--gradient-background--3oaJH";
export var copyContainer = "HalfAndHalfContent-module--copy-container--P3e6C";
export var copyImage = "HalfAndHalfContent-module--copy-image--owsfJ";
export var iconList = "HalfAndHalfContent-module--icon-list--1hUtj";
export var bgGreen = "HalfAndHalfContent-module--bg-green--1uhze";
export var bgWhite = "HalfAndHalfContent-module--bg-white--kYF3W";
export var bgBlack = "HalfAndHalfContent-module--bg-black--3UEYf";
export var bgPurple = "HalfAndHalfContent-module--bg-purple--2-hr2";
export var bgDarkPurple = "HalfAndHalfContent-module--bg-dark-purple--2fOPh";
export var bgPink = "HalfAndHalfContent-module--bg-pink--2a5n7";
export var bgBlue = "HalfAndHalfContent-module--bg-blue--yAhIF";
export var bgLightBlue = "HalfAndHalfContent-module--bg-light-blue--2GrMM";
export var quote = "HalfAndHalfContent-module--quote--1nt4A";
export var attributionImage = "HalfAndHalfContent-module--attribution-image--25893";
export var attribution = "HalfAndHalfContent-module--attribution--3vhCV";
export var person = "HalfAndHalfContent-module--person--139u7";
export var company = "HalfAndHalfContent-module--company--mgFr2";
export var testimonialHeading = "HalfAndHalfContent-module--testimonial-heading--2umFZ";
export var cta = "HalfAndHalfContent-module--cta--SIZYY";
export var copy = "HalfAndHalfContent-module--copy--2XY4C";
export var paragraph = "HalfAndHalfContent-module--paragraph--19BAs";
export var extended = "HalfAndHalfContent-module--extended--hYc4P";